import React from "react"
import { Row, Col } from "reactstrap"
import { Field, reduxForm } from "redux-form"
import { SaveButton } from "components/Buttons"
import { SingleSelectField, TextField } from "components/RenderInput"
import validate from "./sendWebAlertFormValidation"
import { FORM_NAMES } from "constants/index"

const SendWebAlertForm = ({ handleSubmit, handleClose }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col>
          <h6>
            All users, from all clients, which have the dashboard open will get
            this alert.
          </h6>
          <h6>This is global, not client specific.</h6>
        </Col>
      </Row>
      <Row className="form-group mt-3">
        <Col className={"mb-2"}>
          <Field name="alert_title" label="Alert Title" component={TextField} />
        </Col>
      </Row>
      <Row className={"my-2"}>
        <Col className={"mb-2"}>
          <Field name="alert_text" label="Alert Text" component={TextField} />
        </Col>
      </Row>
      <Row className={"my-2"}>
        <Col xs={12} className={"mb-2"}>
          <Field
            name="alert_type"
            component={SingleSelectField}
            placeholder="Select Type"
            label="Alert Type"
            options={[
              { label: "Release alert", value: "1" },
              { label: "Informative alert", value: "2" },
            ]}
            isSearchable={false}
          />
        </Col>
      </Row>
      <Row>
        <Col className={"my-3"}>
          <p>
            NOTE: "Release Alert" will have a Refresh button in the alert;
            "Informative Alert" will just have an OK button
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <SaveButton
            type="button"
            fullWidth={true}
            color="light"
            content="Cancel"
            onClick={handleClose}
          />
        </Col>
        <Col>
          <SaveButton content="Send Alert" fullWidth={true} />
        </Col>
      </Row>
    </form>
  )
}

export default reduxForm({
  form: FORM_NAMES.WEB_ALERT,
  validate,
})(SendWebAlertForm)
